// Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faBars } from '@fortawesome/pro-light-svg-icons/faBars'

// add the imported icons to the library
library.add(
  faBars
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js